<!--
 * @Author: Tina Huang
 * @Date: 2024-01-11 14:48:05
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-01-12 15:37:49
 * @Description: 
-->
<template>
  <div>
    <h2>Notion教程合集</h2>
    <div class="template-list videos-list">
      <div
        class="item"
        :class="item.direction"
        v-for="item in videos"
        :key="item.title"
      >
        <a class="mask" :href="item.link" target="_blank">
          <i class="el-icon-view"></i>
        </a>
        <el-image class="cover" :src="item.cover"></el-image>
        <div class="info">
          <h3>
            {{ item.title }}
          </h3>
          <el-tag
            class="card-tag"
            effect="dark"
            size="small"
            v-for="tag in item.tag"
            :key="tag"
            >{{ tag }}</el-tag
          >
          <p>{{ item.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      videos: [
        {
          title: "如何设计自己的数据库关联",
          cover: require("../../assets/templates/relation.jpg"),
          link: "https://www.bilibili.com/video/BV1ew411r7Mk/?vd_source=4f6a967f85ea30e5aca58f548a5c350e",
          tag: ["formula2.0", "relation"],
          direction: "row",
        },
        {
          title: "⏰ 用Notion做自动化时间管理",
          cover: require("../../assets/templates/timer.jpeg"),
          link: "https://www.bilibili.com/video/BV1fh4y187pd/?vd_source=4f6a967f85ea30e5aca58f548a5c350e",
          tag: ["formula", "tempalte button", "automation"],
          direction: "row",
        },
        {
          title: "👏 Notion 公式2.0版本更新解析教程",
          cover: require("../../assets/templates/formula2.0.jpeg"),
          link: "https://www.bilibili.com/video/BV1Qm4y1V7pn/?vd_source=4f6a967f85ea30e5aca58f548a5c350e",
          tag: ["formula"],
          direction: "row",
        },
        {
          title: "🔥 Notion做月复盘·不得不看的进阶教程",
          cover: require("../../assets/templates/video-month.jpg"),
          link: "https://www.bilibili.com/video/BV1R14y1C7me/?vd_source=4f6a967f85ea30e5aca58f548a5c350e",
          tag: ["relation", "rollup"],
          direction: "row",
        },
        {
          title: "🆕 模版按钮升级啦",
          cover: require("../../assets/templates/video-button.jpg"),
          link: "https://www.bilibili.com/video/BV1hX4y1o7Ab/?vd_source=4f6a967f85ea30e5aca58f548a5c350e",
          tag: ["tempalte button"],
          direction: "row",
        },
        {
          title: "如何在数据库内自动生成体重曲线",
          cover: require("../../assets/templates/video-tizhong.jpg"),
          link: "https://www.bilibili.com/video/BV1tc411E7EZ/?vd_source=4f6a967f85ea30e5aca58f548a5c350e",
          tag: ["formula", "公式计算"],
          direction: "row",
        },
        {
          title: "设置重复/循环任务，自动生成循环事件",
          cover: require("../../assets/templates/video-repeat.jpg"),
          link: "https://www.bilibili.com/video/BV1qv4y1x7Ft/",
          tag: ["Repeat", "循环事件", "自动化"],
          direction: "row",
        },
        {
          title: "自定义打卡项以及打卡汇总设置教程",
          cover: require("../../assets/templates/video-daka.png"),
          link: "https://www.bilibili.com/video/BV1qW4y157tC/?vd_source=4f6a967f85ea30e5aca58f548a5c350e",
          tag: ["relation & rollup"],
          direction: "row",
        },
        {
          title: "游戏闯关式升级人生模版教程",
          cover: require("../../assets/templates/video-habit.png"),
          link: "https://www.bilibili.com/video/BV1Q84y1z7fZ/?vd_source=4f6a967f85ea30e5aca58f548a5c350e",
          tag: ["自律计划", "模版教程"],
          direction: "row",
        },
        {
          title: "打造个人积分打卡系统教程",
          cover: require("../../assets/templates/video-jifen.jpg"),
          link: "https://www.bilibili.com/video/BV1kV4y1s7bE/?vd_source=4f6a967f85ea30e5aca58f548a5c350e",
          tag: ["高阶用法", "公式进度条"],
          direction: "row",
        },
        {
          title: "自选emoji的进度条制作·进度条技巧",
          cover: require("../../assets/emojis.png"),
          link: "https://www.bilibili.com/video/BV1gP411N76P/?vd_source=4f6a967f85ea30e5aca58f548a5c350e",
          tag: ["原生进度条", "自定义进度条"],
          direction: "row",
        },
        {
          title: "遇到多位小数怎么办，一步搞定",
          cover: require("../../assets/nums.jpeg"),
          link: "https://mp.weixin.qq.com/s/lsRpsCu0HlgOsjiqkzxgng",
          tag: ["formula", "保留小数位"],
          direction: "row",
        },
      ],
    };
  },
};
</script>
<style lang="less" scoped>
h2 {
  font-size: 30px;
  text-align: center;
}
.template-list {
  padding-top: 50px;
  display: flex;
  flex-wrap: wrap;
  //   flex-direction: column;
  // justify-content: space-between;
  margin-left: -40px;
  // justify-content: space-around;
  .item {
    display: flex;
    width: 400px;
    border-radius: 10px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 10%);
    margin-bottom: 14px;
    position: relative;
    margin-left: 40px;
    cursor: pointer;
    h3 {
      font-size: 20px;
      margin: 14px 0;
      display: flex;
      align-items: center;
      position: relative;
      .el-tag {
        margin-left: 5px;
        // position: absolute;
      }
    }
    p {
      font-size: 16px;
      margin: 25px 0;
    }
    .copy-btn {
      position: absolute;
      right: 10px;
      bottom: 10px;
    }
    .fix {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 111;
    }
    &.col {
      .cover {
        width: 200px;
        height: 100%;
        display: inline-block;
      }
      .info {
        width: 200px;
        height: 100%;
        box-sizing: border-box;
        padding: 14px;
      }
    }
    &.row {
      flex-direction: column;
      .cover {
        width: 100%;
        height: 170px;
        display: block;
        margin: 0 auto;
        object-fit: fill;
      }
      .info {
        width: 100%;
        height: auto;
        box-sizing: border-box;
        padding: 0 14px;
        p {
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
      }
      .copy-btn {
        bottom: 58px;
      }
    }
  }
}
.videos-list {
  .item.row {
    .cover {
      height: 14vw;
    }
    .mask {
      display: block;
      width: 28vw;
      height: 14vw;
      background: rgba(0, 0, 0, 40%);
      text-align: center;
      line-height: 14vw;
      font-size: 30px;
      color: #ffffff;
      position: absolute;
      z-index: 1;
      opacity: 0;
      transition: all 0.3s;
    }
  }
  .item:hover {
    .mask {
      opacity: 1;
    }
  }
}
.card-tag {
  margin-right: 10px;
}
</style>